import Axios from 'axios'

const axios = Axios.create({
  baseURL: 'http://test.sayyoo.uqugu.com:29899/dicts',
})

export const enumsNameList = ['rentType', 'cycle', 'signType']

function reduceEnums(dicts) {
  const ret = {}
  for (const dict of dicts) {
    const name = dict.name
    if (ret.hasOwnProperty(name)) {
      ret[name] = ret[name].concat(dict)
    } else {
      ret[name] = [dict]
    }
  }
  return ret
}

export default async function getDicts(nameList = enumsNameList) {
  try {
    const res = await axios.get('')
    if (!res.data.success) {
      return Promise.reject(res.data)
    }

    const data = res.data.data.filter(o => nameList.includes(o.name))
    return [reduceEnums(data), data]
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/data/init.js